import { useTranslate } from '../../hooks'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Tabs,
  TabsList,
  TabsTrigger,
} from '@repo/ui/components'
import { useIsDesktop } from '@repo/ui/hooks'
import type {
  AdvancedTradeBoxOrderType,
  AdvancedTradeBoxOrderTypeSelectProps,
} from './advanced-trade-box.types'

export const AdvancedTradeBoxOrderTypeSelect = ({
  orderType,
  onChange,
}: AdvancedTradeBoxOrderTypeSelectProps) => {
  const { t } = useTranslate()
  const isDesktop = useIsDesktop()

  // Desktop - Tabs
  if (isDesktop) {
    return (
      <Tabs
        value={orderType}
        onValueChange={(value) => onChange(value as AdvancedTradeBoxOrderType)}
        className='w-full'
      >
        <TabsList className='grid w-full grid-cols-3'>
          <TabsTrigger value='limit' className='flex-1'>
            {t('order_limit_finglish')}
          </TabsTrigger>
          <TabsTrigger value='market' className='flex-1'>
            {t('order_market_finglish')}
          </TabsTrigger>
          <TabsTrigger value='stop-limit' className='flex-1'>
            {t('order_stop_limit')}
          </TabsTrigger>
        </TabsList>
      </Tabs>
    )
  }

  // Mobile - Select
  return (
    <Select
      dir='rtl'
      value={orderType}
      onValueChange={(value) => onChange(value as AdvancedTradeBoxOrderType)}
    >
      <SelectTrigger className='w-full' inputSize='sm'>
        <SelectValue placeholder={t('order_type')} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value='limit'>{t('order_limit_finglish')}</SelectItem>
        <SelectItem value='market'>{t('order_market_finglish')}</SelectItem>
        <SelectItem value='stop-limit'>{t('order_stop_limit')}</SelectItem>
      </SelectContent>
    </Select>
  )
}
